// 타깃 공지 전면 안내 — 어느 공지를 띄울지 고르는 순수 함수(2026-10-28 · 마이그레이션 20261206100000).
// 내가 받은 공지 중 gate = true · 발행됨 · 아직 「확인했습니다」(confirmed_at) 전인 것, 가장 최근 발행 1건.
// 화면(AnnouncementGate)이 쓰고, 테스트(announcementGate.test.js)가 규칙을 지킨다.

/**
 * @param {Array<{id, gate, status, published_at}>} anns  announcement 행
 * @param {Array<{announcement_id, confirmed_at}>} recips  내 announcement_recipient 행
 * @returns {object|null}
 */
export function pickGateAnnouncement(anns, recips) {
  const pending = new Set((recips || []).filter((r) => !r.confirmed_at).map((r) => r.announcement_id));
  const list = (anns || []).filter((a) => a && a.gate === true && a.status === "published" && pending.has(a.id));
  if (!list.length) return null;
  list.sort((a, b) => String(b.published_at || "").localeCompare(String(a.published_at || "")));
  return list[0];
}
